import repo from 'service/repository';
import { PATH } from 'config';
import { getCpcId } from 'service/local-data-provider';

const welcomeList = ['intro', 'parkinglots', 'onStreetParking'];

const onBoardingAddPlateNumberData = {
  promises: [repo.fetchUserInfo, repo.fetchLicensePlates, repo.fetchBootstraps, () => repo.updatePushToken(getCpcId())],
  path: PATH.USER_BIND_CPC_PAY_CARD,
};

const mainFeaturesList = ['parking', 'on-street-parking'];

const bottomTabList = ['main', 'maps', 'orders'];

const ordersList = [
  { key: 'parking', value: '停車場' },
  { key: 'on_street_parking', value: '路邊停車格' },
];

const configData = {
  welcomeList,
  onBoardingAddPlateNumberData,
  mainFeaturesList,
  bottomTabList,
  ordersList,
};

export default configData;
